import { SupportCenterTypes } from "../../../utils/SupportCenterLinks"

// Register some callbacks that the native implementations will dynamically call back with the response
// It's ugly but we don't have another choice at this time.
const initGlobalCallbacks = () => {
  const g = getGlobal()
  // @ts-expect-error TS7006
  g.isBiometricsCapable = (isCapable) => {
    g._isBiometricsCapable = isCapable
  }

  // @ts-expect-error TS7006
  g.isBiometricLoginAlreadyConfigured = (isAlreadyConfigured) => {
    g._isBiometricLoginAlreadyConfigured = isAlreadyConfigured
  }

  g.showEnrollmentSuccess = () => {
    getGlobal()._biometricEnrollmentSuccess()
  }

  g.showEnrollmentFailure = () => {
    getGlobal()._biometricEnrollmentFailure()
  }

  g.biometricLoginFailure = () => {
    // Not currently used
  }

  // @ts-expect-error TS7006
  g.biometricLogin = (username, password) => {
    g._bioAuthenticatedUsername = username
    g._bioAuthenticatedPassword = password
    getGlobal()._login(username, password)
  }
}

function getGlobal() {
  return (function (global) {
    return global
    // eslint-disable-next-line no-new-func -- we should change this to use `globalThis` https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis
  })(new Function("return this;")())
}

type CarrotBridgePayload = {
  action: "showZendesk"
  data: {
    jwt: string
    sectionId?: number
    articleId?: number
  }
}

// @ts-expect-error TS7006
const getCarrotBridgePayload = (token, type, id) => {
  const payload: CarrotBridgePayload = {
    action: "showZendesk",
    data: {
      jwt: `${token}`
    }
  }
  if (type === SupportCenterTypes.SECTIONS && id) {
    payload.data.sectionId = Number(id)
  }

  if (type === SupportCenterTypes.ARTICLES && id) {
    payload.data.articleId = Number(id)
  }
  return payload
}

export { getCarrotBridgePayload, initGlobalCallbacks, getGlobal }
